'use client'
import React, { useState } from 'react';

const EducationIndustries = ({ color, textcolor, active, activetext }) => {
  const [activeTab, setActiveTab] = useState('first');

  return (
    <section className={`${color} text-${textcolor} mt-20`}>
      <div className="container mt-5">
        <div className="text-center">
          <h2 className="sec-subtile-6">IT Solutions for Education and E-Learning Industry</h2>
        </div>
        <h3 className="text-center py-3">Comprehensive IT Solutions for Education and E-Learning</h3>
        <p className="text-center py-3">
          We provide a wide range of IT solutions for the education and e-learning sector, including custom learning management systems, virtual classrooms, and mobile learning platforms. Our solutions are designed to improve the learning experience and streamline administrative tasks.
        </p>
        <div className="row mt-5">
          {/* Tab section */}
          <div className="col-md-3 col-sm-12 py-2">
            <div className="d-flex flex-column align-items-center  h-100">

              <div className="d-block d-sm-none overflow-x-auto whitespace-nowrap w-100">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'first' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('first')}
                >
                  Learning Management System (LMS)
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'second' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('second')}
                >
                  Virtual Classroom Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'third' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('third')}
                >
                  E-Learning Platforms
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 ml-2 sm:mb-0 ${activeTab === 'four' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('four')}
                >
                  Mobile Learning Applications
                </button>
              </div>

              <div className="d-none d-sm-flex flex-column ">
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'first' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('first')}
                >
                  Learning Management System (LMS)
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'second' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('second')}
                >
                  Virtual Classroom Solutions
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'third' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('third')}
                >
                  E-Learning Platforms
                </button>
                <button
                  className={`px-4 py-2 border border-gray-500 rounded-md mb-2 sm:mb-0 ${activeTab === 'four' ? `${active} ${activetext}` : 'hover:bg-white hover:text-black'}`}
                  onClick={() => setActiveTab('four')}
                >
                  Mobile Learning Applications
                </button>
              </div>
            </div>
          </div>


          {/* Icon section */}
          <div className="col-md-9 col-sm-12 ">
            <div className="-brand__list -showcase-mixitup mt-3">
              {/* First Tab: EMR Solutions */}
              {activeTab === 'first' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Learning Management System (LMS)</h3>
                        <p>
                          Our custom LMS platforms improve the management and delivery of educational content for institutions. With features like course creation, tracking, and reporting, our LMS ensures an engaging learning experience and smooth course management.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Course Creation and Management</h4>
                          <p>Create and organize courses with a simple, intuitive interface.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Student Enrollment and Management  </h4>
                          <p>Easily manage student registrations and class enrollments.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Assessment and Grading Tools</h4>
                          <p>Automate grading with flexible tools for assignments and exams.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Progress Tracking and Reporting</h4>
                          <p>Track student progress with detailed analytics and reports.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Student-Teacher Communication</h4>
                          <p>Enable seamless communication between students and teachers.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h4 className="workflow__title-6">Mobile <br />Learning</h4>
                          <p>Offer easy access to courses through mobile devices.</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}

              {/* Second Tab: Telemedicine Solutions */}
              {activeTab === 'second' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Virtual Classroom Solutions</h3>
                        <p>
                          We build virtual classroom software that provides an interactive and immersive learning experience. Our solutions enable real-time video lectures, discussions, and collaboration, bringing the traditional classroom experience online.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Live Streaming</h6>
                          <p>Conduct live video and audio sessions with high-quality streaming.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Interactive Tools</h6>
                          <p>Use whiteboards and chat for real-time classroom interactions.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Group Discussions</h6>
                          <p>Split students into breakout rooms for focused discussions.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Attendance Tracking</h6>
                          <p>Automatically monitor student attendance during sessions.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Session Recordings</h6>
                          <p>Record and store classes for future playback by students.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">File Sharing</h6>
                          <p>Facilitate easy sharing of class materials and resources.</p>
                        </div>
                      </div>
                    </div>

                  </section>
                </>
              )}

              {/* Third Tab: HMS Solutions */}
              {activeTab === 'third' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3"> E-Learning Platforms</h3>
                        <p>
                          Our custom e-learning platforms are designed for universities, businesses, and training centers, providing a robust solution for online education and corporate training. These platforms offer comprehensive course management, multimedia content delivery, and assessments.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Content Delivery</h6>
                          <p>Deliver multimedia-rich courses with interactive learning tools.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Certifications</h6>
                          <p>Provide certificates for completed courses and accredited programs.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Quiz Modules</h6>
                          <p>Assess student knowledge with customizable quizzes and tests.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Forums</h6>
                          <p>Enable discussions through community boards and group forums.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Payments</h6>
                          <p>Integrate payment systems for enrolling in premium courses.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Analytics</h6>
                          <p>Access real-time data on course progress and student performance.</p>
                        </div>
                      </div>
                    </div>

                  </section>
                </>
              )}

              {/* Fourth Tab: HIE Solutions */}
              {activeTab === 'four' && (
                <>
                  <section>
                    <div className="row">
                      <div className="col-12 text-center">
                        <h3 className="mb-3">Mobile Learning Applications</h3>
                        <p>
                          Our mobile learning apps offer flexibility for learners to access educational content from anywhere, at any time. These apps are designed to provide an interactive and user-friendly experience on smartphones and tablets.
                        </p>
                      </div>
                    </div>
                    <div className="container g-0 mt-[40px] pb-0">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Offline Access</h6>
                          <p>Allow learners to download materials and study offline.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Push Alerts</h6>
                          <p>Send notifications for new assignments and course updates.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Interactive Tools</h6>
                          <p>Use quizzes and flashcards for interactive mobile learning.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Course Access</h6>
                          <p>View lectures, materials, and assignments on any mobile device.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Video Lectures</h6>
                          <p>Access recorded lectures and live-streamed sessions on the go.</p>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 p-3 mb-3 rounded-lg">
                          <h6 className="workflow__title-6">Peer Communication</h6>
                          <p>Communicate with classmates and teachers directly through the app.</p>
                        </div>
                      </div>
                    </div>

                  </section>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default EducationIndustries;
